import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=1a596d22&scoped=true&"
import script from "./Menu.js?vue&type=script&lang=js&"
export * from "./Menu.js?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=1a596d22&prod&lang=scss&scoped=true&"
import style1 from "./Menu.vue?vue&type=style&index=1&id=1a596d22&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a596d22",
  null
  
)

export default component.exports